import React, { memo } from "react";
import KsbItAppBarContent from "./KsbItAppBarContent";
import { AppBar, Toolbar } from "@mui/material";
import { useTheme } from "@mui/material/styles"; // ✅ CORRECT
function KsbItAppBar() {
  const theme = useTheme();
  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: theme.palette.primary.dark, // ✅ correct
        height: "4rem",
        // px: "1rem",
        width: "100%",
      }}
    >
      <Toolbar sx={{ minHeight: "4rem", width: "100%" }}>
        <KsbItAppBarContent />
      </Toolbar>
    </AppBar>
  );
}
export default memo(KsbItAppBar);
